"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.join.js");

var _message = require("@/components/dialog/message.js");

var _index = require("@/model/assets/index");

var _qrcode = _interopRequireDefault(require("qrcode.vue"));

var _settings = require("@/model/settings");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _element = require("@/assets/js/element");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default,
    QrcodeVue: _qrcode.default
  },
  props: ["data"],
  data: function data() {
    return {
      // onSelectBlur,
      // onSelectFilter,
      ua_id: "",
      uaid: "",
      checked: false,
      dialogVisible: false,
      createVisible: false,
      modifyVisible: false,
      delVisible: false,
      modifyLoading: false,
      delLoading: false,
      creatLoading: false,
      dataLoading: true,
      qr_code: "",
      active: "",
      isRecharge: true,
      addressActive: "",
      coinInfo: [],
      chainMap: {},
      address: "",
      addressList: [],
      addressList4Tag: {},
      // addressOptions: [],
      addressData: {
        address: "",
        bak: "",
        qrcode_url: "",
        transactions: "",
        chain_tag: "",
        ua_id: ""
      },
      bak: "",
      new_bak: "",
      chain_tag: "",
      time: "",
      isModify: false,
      isScroll: false,
      qrcodeLoading: false
    };
  },
  created: function created() {
    this.default_chain = this.data.itemDetail.default_chain.toUpperCase(); // this.chain_tag = this.data.itemDetail.default_chain.toUpperCase();

    this.isRecharge = this.data.itemDetail.in_status == 1 ? true : false;
    this.getStaticChainInfo();
  },
  computed: {
    coinInfoComputed: function coinInfoComputed() {
      var tempObj = [];

      for (var key in this.coinInfo) {
        if (this.data.itemDetail.coin_id == this.coinInfo[key].value) {
          tempObj.push({
            key: this.coinInfo[key].value,
            value: this.coinInfo[key].label,
            label: this.coinInfo[key].label.toUpperCase()
          });
        }
      }

      if (tempObj.length > 0) {
        this.chain_tag = tempObj[0].label;
      } else {
        this.chain_tag = this.data.itemDetail.default_chain.toUpperCase();
      }

      var erc20 = {};
      var trc20 = {};
      tempObj.forEach(function (ele) {
        if (ele.label === "ERC20") erc20 = ele;
        if (ele.label === "TRC20") trc20 = ele;
      });
      var newtempObj = tempObj.filter(function (ele) {
        return ele.label != "ERC20" && ele.label != "TRC20";
      });

      if (JSON.stringify(erc20) != "{}") {
        newtempObj.push(erc20);
      }

      if (JSON.stringify(trc20) != "{}") {
        newtempObj.unshift(trc20);
      } // 默认erc20
      // tempObj.forEach((ele) => {
      //   if (ele.value == "erc20") {
      //     this.active = ele.value;
      //   }
      // });


      return newtempObj;
    },
    // getScroll() {
    //   if (this.addressList.length > 6) {
    //     return { "overflow-y": "auto", "overflow-x": "hidden" };
    //   }
    // },
    getScrollClass: function getScrollClass() {
      var tempVal = "";

      if (this.addressList.length > 6) {
        tempVal = "scroll-calss";
      } else {
        tempVal = "";
      }

      return tempVal;
    }
  },
  // watch: {
  //   addressData() {
  //     this.qrcodeLoading = true;
  //   }
  // },
  methods: {
    // onQrcodeLoad() {
    //   this.qrcodeLoading = false;
    // },
    // async getStaticCoinInfo() {
    //   await apiGetStaticTableInfo(57).then(({ data }) => {
    //     for (const key in data) {
    //       this.coinInfo.push({
    //         label: data[key].chain.toUpperCase(),
    //         value: data[key].coin_id,
    //       });
    //     }
    //   });
    // },
    //  async getStaticChainInfo() {
    //   await apiGetStaticTableInfo(56).then(({ data }) => {
    //    this.chainMap = data
    //   });
    // },
    // initCoinInfo(){
    //  this.coinInfo.forEach(ele=>{
    //    for(let item in this.chainMap){
    //      if(ele.label == this.chainMap[item].chain_tag.toUpperCase()){
    //        if(this.chainMap[item].status==1)
    //        ele.chain_status = this.chainMap[item].status
    //      }
    //    }
    //  })
    // },
    getStaticChainInfo: function getStaticChainInfo() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.coinInfo = [];
                _context.next = 3;
                return (0, _settings.apiGetStaticTableInfo)(56).then(function (_ref) {
                  var data = _ref.data;
                  _this.chainMap = data;
                });

              case 3:
                _context.next = 5;
                return (0, _settings.apiGetStaticTableInfo)(57).then(function (_ref2) {
                  var data = _ref2.data;

                  for (var key in data) {
                    for (var item in _this.chainMap) {
                      if (data[key].chain.toUpperCase() == _this.chainMap[item].chain_tag.toUpperCase() && data[key].status == 1 && _this.chainMap[item].status == 1) {
                        _this.coinInfo.push({
                          label: data[key].chain.toUpperCase(),
                          value: data[key].coin_id,
                          rate_out: data[key].fee,
                          is_default: data[key].is_default,
                          chain_status: _this.chainMap[item].status,
                          status: data[key].status,
                          minout: data[key].minout,
                          maxout: data[key].maxout
                        });
                      }
                    }
                  }
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selectChange: function selectChange(val) {
      var _this2 = this;

      this.addressList.forEach(function (item) {
        if (val == item.ua_id) {
          _this2.addressData = item;
          _this2.ua_id = val;
        }
      });
    },
    scrollAdress: function scrollAdress() {
      this.isScroll = true;
    },
    onCreate: function onCreate() {
      this.createVisible = true;
      this.time = parseInt(new Date().getTime() / 1000);
      this.bak = this.translateTitle("\u65B0\u5730\u5740") + this.time;
      this.isModify = false;
    },
    onModify: function onModify() {
      this.modifyVisible = true;
      this.selectChange(this.ua_id);
      this.new_bak = this.addressData.bak;
    },
    onDelete: function onDelete() {
      this.delVisible = true;
      this.isModify = false;
    },
    //删除确认
    onDeleteConfirm: function onDeleteConfirm() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$apiDelFinanceA, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.delLoading = true;
                req = {
                  ua_id: _this3.ua_id
                };
                _context2.next = 4;
                return (0, _index.apiDelFinanceAddress)(req);

              case 4:
                _yield$apiDelFinanceA = _context2.sent;
                status = _yield$apiDelFinanceA.status;
                data = _yield$apiDelFinanceA.data;
                _this3.delLoading = false;

                if (status == 200) {
                  _this3.getAddress(_this3.chain_tag);

                  _this3.delVisible = false;
                  (0, _message.showMessage)({
                    message: "删除成功",
                    type: "success"
                  });
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    //修改确认
    onModifyConfirm: function onModifyConfirm() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var req, _yield$apiSaveFinance, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this4.new_bak) {
                  _context3.next = 17;
                  break;
                }

                if (!(_this4.new_bak == _this4.addressData.bak)) {
                  _context3.next = 6;
                  break;
                }

                _this4.modifyVisible = false;
                return _context3.abrupt("return");

              case 6:
                req = {
                  ua_id: _this4.ua_id,
                  bak: _this4.new_bak
                };
                _this4.modifyLoading = true;
                _context3.next = 10;
                return (0, _index.apiSaveFinanceAddress)(req);

              case 10:
                _yield$apiSaveFinance = _context3.sent;
                status = _yield$apiSaveFinance.status;
                data = _yield$apiSaveFinance.data;
                _this4.modifyLoading = false;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this4.translateTitle("\u4FEE\u6539\u6210\u529F"),
                    type: "success"
                  });

                  _this4.getAddress(_this4.chain_tag);

                  _this4.new_bak = "";
                  _this4.isModify = true;
                  _this4.modifyVisible = false;
                }

              case 15:
                _context3.next = 18;
                break;

              case 17:
                (0, _message.showMessage)({
                  message: _this4.translateTitle("\u8BF7\u8F93\u5165\u65B0\u5907\u6CE8\u540D"),
                  type: "error"
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onModifyClose: function onModifyClose() {
      this.new_bak = "";
    },
    onCreateClose: function onCreateClose() {
      this.bak = "";
    },
    mainClose: function mainClose() {
      this.isModify = false;
      this.dialogVisible = false; // this.chain_tag = "erc20";
    },
    //新增确认
    onCreateConfirm: function onCreateConfirm() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var req, _yield$apiCreateFinan, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this5.bak) {
                  _context4.next = 13;
                  break;
                }

                _this5.creatLoading = true;
                req = {
                  item_id: _this5.data.item_id,
                  bak: _this5.bak
                }; // if (!this.data.itemDetail.multi_chain_status) {
                //   this.active = "";
                // } else {
                //   req.chain_tag = this.chain_tag;
                // }

                req.chain_tag = _this5.chain_tag;
                _context4.next = 6;
                return (0, _index.apiCreateFinanceAddress)(req);

              case 6:
                _yield$apiCreateFinan = _context4.sent;
                status = _yield$apiCreateFinan.status;
                data = _yield$apiCreateFinan.data;
                _this5.creatLoading = false;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this5.translateTitle("\u751F\u6210\u65B0\u5145\u5E01\u5730\u5740\u6210\u529F"),
                    type: "success"
                  });

                  _this5.getAddress(_this5.chain_tag);

                  _this5.bak = "";
                  _this5.createVisible = false;
                }

                _context4.next = 14;
                break;

              case 13:
                (0, _message.showMessage)({
                  message: _this5.translateTitle("\u8BF7\u8F93\u5165\u65B0\u5730\u5740\u5907\u6CE8\u540D"),
                  type: "error"
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 选项卡切换
    onTypeChange: function onTypeChange(val) {
      this.isModify = false;
      this.chain_tag = val; // this.getAddress(val);

      this.onChangeTag(val);
    },
    //切换链选项卡
    onChangeTag: function onChangeTag(tagName) {
      this.active = tagName.toUpperCase();
      this.addressList = this.addressList4Tag[tagName.toLowerCase()]; // this.addressList = data;  //pangpang注释
      // this.addressOptions = data; //pangpang注释

      if (!this.isModify) {
        if (this.addressList4Tag[tagName.toLowerCase()].length > 0) {
          this.addressData = this.addressList4Tag[tagName.toLowerCase()][0];
          this.ua_id = this.addressData.ua_id;
          this.addressActive = this.addressData.ua_id; // this.onAddressChange(this.ua_id);
        } else {
          this.addressList = [];
          this.addressData = [];
        }
      } else {
        this.onAddressChange(this.ua_id);
      }

      this.dialogVisible = true;
    },
    onAddressChange: function onAddressChange(val) {
      var _this6 = this;

      //   this.$refs.scorllRef.scrollTo(0,0)
      // //   window.scrollTo(0,0);   // chrome
      // // document.body.scrollTop = 0
      this.addressActive = val;
      this.addressList.forEach(function (item) {
        if (val == item.ua_id) {
          _this6.addressData = item;
          _this6.ua_id = val;
        }
      });
    },
    onFilterNewBak: function onFilterNewBak(val) {
      this.new_bak = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\$]/g, "");
    },
    onFilterBak: function onFilterBak(val) {
      this.bak = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\$]/g, "");
    },
    copySuccess: function copySuccess() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u6210\u529F"),
        type: "success"
      });
    },
    copyError: function copyError() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u5931\u8D25")
      });
    },
    // 获取充币地址
    getAddress: function getAddress(val) {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var item_id, params, chain_tag_temp, chain_tag_strings, _yield$apiGetFinanceA, status, msg, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // if (!this.checked) {
                //   showMessage({ message: "请先确认是否要充值" });
                //   return;
                // }  coinInfoComputed
                // this.chain_tag = val;  //pangpang注释
                item_id = _this7.data.item_id;
                params = {
                  item_id: item_id
                }; // if (!this.data.itemDetail.multi_chain_status) {
                //   this.active = "";
                // } else {
                //   params.chain_tag_list = this.chain_tag;
                // }

                chain_tag_temp = [];
                chain_tag_strings = ""; // if (!val) {

                _this7.coinInfoComputed.forEach(function (item) {
                  chain_tag_temp.push(item.value);
                });

                chain_tag_strings = chain_tag_temp.join(",");
                params.chain_tag_list = chain_tag_strings; // } else {
                //   params.chain_tag_list = val;
                // }

                _context5.next = 9;
                return (0, _index.apiGetFinanceAddressList)(params);

              case 9:
                _yield$apiGetFinanceA = _context5.sent;
                status = _yield$apiGetFinanceA.status;
                msg = _yield$apiGetFinanceA.msg;
                data = _yield$apiGetFinanceA.data;

                // apiGetFinanceAddressList(params).then(({ status, msg, data }) => {
                if (status === 200) {
                  // if (val) {                          //pangpang 注释
                  //   this.active = val.toUpperCase();
                  // }
                  _this7.active = _this7.chain_tag.toUpperCase();
                  chain_tag_temp.forEach(function (tag) {
                    _this7.addressList4Tag[tag.toLowerCase()] = [];
                    data.forEach(function (ele) {
                      if (tag.toLowerCase() == ele.chain_tag) {
                        _this7.addressList4Tag[tag.toLowerCase()].push(ele);
                      }
                    });
                  });
                  _this7.addressList = _this7.addressList4Tag[_this7.chain_tag.toLowerCase()]; // this.addressList = data;  //pangpang注释
                  // this.addressOptions = data; //pangpang注释

                  if (!_this7.isModify) {
                    if (_this7.addressList4Tag[_this7.chain_tag.toLowerCase()].length > 0) {
                      _this7.addressData = _this7.addressList4Tag[_this7.chain_tag.toLowerCase()][0];
                      _this7.ua_id = _this7.addressData.ua_id;
                      _this7.addressActive = _this7.addressData.ua_id; // this.onAddressChange(this.ua_id);
                    } else {
                      _this7.addressList = [];
                      _this7.addressData = [];
                    }
                  } else {
                    _this7.onAddressChange(_this7.ua_id);
                  } // if (!this.isModify) {
                  //   if (data.length > 0) {
                  //     this.addressData = data[0];
                  //     this.ua_id = this.addressData.ua_id;
                  //     this.addressActive = this.addressData.ua_id;
                  //     // this.onAddressChange(this.ua_id);
                  //   } else {
                  //     this.addressList = [];
                  //     this.addressData = [];
                  //   }
                  // } else {
                  //   this.onAddressChange(this.ua_id);
                  // }


                  _this7.dialogVisible = true;
                } else {
                  (0, _message.showMessage)({
                    message: msg ? msg : status
                  });
                }

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};
exports.default = _default;